import React from 'react'
import { connect } from 'react-redux'
import withNavigate from '../../../components/common/withNavigate'
import SSOConnect from './SSO-Connect'
import SSOSignIn from './SSO-SignIn'
import SSOSuccess from './SSO-Success'
import SSOTerms from './SSO-Terms'
import SSOSignUp from './SSO-SignUp'
import SSOVerifyAccount from './SSO-VerifyAccount'
import SSOToast from './SSO-Toast'
import SSOForgotPassword from './SSO-Forgot-Password'
import SSOResendVerificationEmail from './SSO-Resend-Verification-Email'
import constants from '../../../utils/constants'
import { FormattedMessage } from 'react-intl';

class SSO extends React.Component {
  state = {
    page: constants.CMSESSOPages.Connect,
    lastPage:'',
    historyPages: [],
    verifyAccountEmail: '',
    showToast: false,
    connecting: false,
  };

  switchPage(page, back=false) {
    if(!back){
      this.state.historyPages.push(this.state.page);
    }
    this.setState({
      historyPages: this.state.historyPages,
      lastPage: page === constants.CMSESSOPages.Connect ? '' : this.state.page, 
      page:page
    })
  }

  renderSwitch(page) {
    switch(page) {
      case constants.CMSESSOPages.Connect:
        return <SSOConnect 
                onClickConnectBtn={()=>{this.switchPage(constants.CMSESSOPages.SignIn)}}
                product={this.props.product} />;
      case constants.CMSESSOPages.SignIn:
        return <SSOSignIn 
                onSuccess={()=>{this.switchPage(constants.CMSESSOPages.Success)}} 
                onAgreeTerms={()=>{this.switchPage(constants.CMSESSOPages.TermsAndConditions)}}
                onForgotPassword={()=>{this.switchPage(constants.CMSESSOPages.ForgotPassword)}}
                onResendVerificationEmail={()=>{this.switchPage(constants.CMSESSOPages.ResendVerificationEmail)}}
                setConnetingStatus={this.setConnetingStatus}  
                product={this.props.product} />;
      case constants.CMSESSOPages.Success:
        return <SSOSuccess product={this.props.product} />
      case constants.CMSESSOPages.TermsAndConditions:
        return <SSOTerms onSignUp={()=>{this.switchPage(constants.CMSESSOPages.SignUp)}} product={this.props.product} />;
      case constants.CMSESSOPages.SignUp:
        return <SSOSignUp 
                onSignIn={()=>{this.switchPage(constants.CMSESSOPages.SignIn)}}
                onVerifyAccount={(email)=>{this.setState({verifyAccountEmail: email}); this.switchPage(constants.CMSESSOPages.VerifyAccount)}} 
                product={this.props.product} 
              />;
      case constants.CMSESSOPages.VerifyAccount:
        return <SSOVerifyAccount 
                email={this.state.verifyAccountEmail} 
                onSignIn={()=>{this.setState({showToast: true}); this.switchPage(constants.CMSESSOPages.SignIn)}}
                product={this.props.product} 
              />;
      case constants.CMSESSOPages.ForgotPassword:
        return <SSOForgotPassword 
        email={this.state.verifyAccountEmail} 
        onSignIn={()=>{this.switchPage(constants.CMSESSOPages.SignIn)}}
        product={this.props.product} 
      />;
      case constants.CMSESSOPages.ResendVerificationEmail:
        return <SSOResendVerificationEmail
        onSignIn={()=>{this.switchPage(constants.CMSESSOPages.SignIn)}}
        product={this.props.product} 
      />;
      default:
        return <SSOSignIn product={this.props.product} />;
    }
  }

  PopupToast = () => {
    return(
      <SSOToast showToast={this.state.showToast} toastMessage={<FormattedMessage id="ACCOUNT_CREATED_SUCCESS" />} toastType="success" setShowToast={this.setShowToast}/>
    )  
  }

  setShowToast = (showToast) => {
    this.setState({showToast});   
  }

  setConnetingStatus = (connecting) => {
    this.setState({connecting});   
  }

  render () {
    return (
      <div className='login login_SSOCMS container py-3 h-100'>
        <div className='SSOCMS row d-flex justify-content-center p-0'>         
          <div className={this.state.page === constants.CMSESSOPages.Connect ? 'col-xl-12' : 'col-xl-8'}>
            {(this.state.lastPage !== '' && !this.state.connecting) &&
              <div className='d-flex mb-2'>
                <img className="label_hover" alt="" src="/images/chevron-left.svg" onClick={()=> this.switchPage(this.state.historyPages.pop(), true)}/>
                <label className='label_hover red' onClick={()=>this.switchPage(this.state.historyPages.pop(), true)}><FormattedMessage id="BACK_BTN" /></label>
              </div>
            }
            <form>
              {this.renderSwitch(this.state.page)}
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(withNavigate(SSO))
